import axios from "axios";
import { getBaseUrl, Microservice } from "../constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

interface SubmitSkuPoOcrRequest {
  ids: number[];
  token: string;
  orgRoleId: number;
}

const deleteSkuPoOcr = async ({
  token,
  ids,
  orgRoleId,
}: SubmitSkuPoOcrRequest) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.SKU_FINANCE)}/sku-finance/loan-application/submit-sku-po-ocr`,
      { ids, orgRoleId },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    throw new Error(message);
  }
};
export default deleteSkuPoOcr;
